import moment from 'moment';
import * as _ from 'underscore';
import { Injectable } from '@angular/core';
import { IObject } from '@type_definitions/datatypes';

export const DEFAULT_DATE_FORMAT:string = 'DD/MM/YYYY';

export enum DateType {
  TODAY = 'sysdate',
  YESTERDAY = 'sysdate-1',
  THREE_DAYS_AGO = 'sysdate-3',
  ONE_WEEK_AGO = 'sysdate-7',
  THIRTY_DAYS_AGO = 'sysdate-30',
  LAST_OF_PREVIOUS_MONTH = 'trunc(sysdate,\'MM\')-1',
  NINETY_DAYS_AGO = 'sysdate-90',
  ONE_YEAR_AGO = 'sysdate-365',
  FIRST_OF_PREVIOUS_YEAR = 'trunc(trunc(sysdate,\'YYYY\')-1,\'YYYY\')'
}

export const SHORT_MONTHS_ORDER:IObject<number> = {
  Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
  Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12
};

/**
 * @ngdoc service
 * @name ga2.common.service:dateUtil
 *
 * @description
 * The dateUtil is a date utility
 *
 */
@Injectable()
export class DateUtil {

  private static SYSDATE_REGEX = /^\s*sysdate(?:\s*([+-])\s*(\d+))?\s*$/i; //e.g. SYSDATE + 1
  private static DATE_REGEX = /^\d{2}\/\d{2}\/\d{4}$/; //e.g. 01/01/2014

  /**
   * @ngdoc method
   * @name ga2.common.service:dateUtil#parseSysDate
   * @methodOf ga2.common.service:dateUtil
   *
   * @description Converts provided date in sysdate format into Date value
   *
   * @param {string} value - date value that has to be converted
   */
  public parseSysdate(value:string):Date {
    const parsed = moment();

    if (!this.testSysdate(value)) {
      return undefined;
    }

    const matched = value.match(DateUtil.SYSDATE_REGEX);
    if (!matched) {
      return undefined;
    }

    const op = matched[ 1 ];
    const num = matched[ 2 ];

    if (op === '-') {
      parsed.subtract(num, 'days');
    } else if (op === '+') {
      parsed.add(num, 'days');
    }

    return parsed.toDate();
  }

  /**
   * @ngdoc method
   * @name ga2.common.service:dateUtil#testSysdate
   * @methodOf ga2.common.service:dateUtil
   *
   * @description Checks if provided value is a sysdate value
   *
   * @param {string} value - date value that has to be checked
   */
  public testSysdate(value:string):boolean {
    return !!value && _.isString(value) && !value.match(DateUtil.DATE_REGEX);
  }

}